import * as dashboardTypes from './dashboardTypes';

export const setDashboardType = dashboardType => {
  return dispatch => {
    sessionStorage.setItem('dashboardType', dashboardType);
    dispatch({
      type: dashboardTypes.SET_DASHBOARD_TYPE,
      dashboardType,
    });
  };
};

export const setTaskType = dashboardType => {
  sessionStorage.setItem('dashboardType', dashboardType);
  return dispatch => {
    dispatch({
      type: dashboardTypes.SET_DASHBOARD_TYPE,
      dashboardType,
    });
  };
};

export const setSelectedMenuType = flag => {
  return {
    type: dashboardTypes.SET_SELECTED_MENU_TYPE,
    flag,
  };
};
